export let option = {
  heart_opt: {
    title: {
      text: '心率图'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      // boundaryGap: true,
      data: []
    },
    yAxis: {
      min: 0,
      max: 180
    },
    series: [
      // {
      //   name: 'Email',
      //   type: 'line',

      //   data: [60, 66,62,63,70,89,90,65,61,63,64,68,77,72,82,81,75,83,65,71,67,68,76,77,79,80,81,82,83,84,85,86,87,88,65]
      // },

    ]
  },
  blood_opt: {
    title: {
      text: '血压图'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      // boundaryGap: true,
      data: []
    },
    yAxis: {
      min: 0,
      max: 150
    },
    series: [
      // {
      //   name: 'Email',
      //   type: 'line',

      //   data: [60, 66,62,63,70,89,90,65,61,63,64,68,77,72,82,81,75,83,65,71,67,68,76,77,79,80,81,82,83,84,85,86,87,88,65]
      // },

    ]
  },
  oxg_opt: {
    title: {
      text: '血氧图'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      // boundaryGap: true,
      data: []
    },
    yAxis: {
      min: 0,
      max: 100
    },
    series: [
      // {
      //   name: 'Email',
      //   type: 'line',

      //   data: [60, 66,62,63,70,89,90,65,61,63,64,68,77,72,82,81,75,83,65,71,67,68,76,77,79,80,81,82,83,84,85,86,87,88,65]
      // },

    ]
  },
  sleep_opt: {
    title: {
      text: '睡眠图'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      // boundaryGap: true,
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: [
      // {
      //   name: 'Email',
      //   type: 'line',

      //   data: [60, 66,62,63,70,89,90,65,61,63,64,68,77,72,82,81,75,83,65,71,67,68,76,77,79,80,81,82,83,84,85,86,87,88,65]
      // },

    ]
  },
  step_opt: {
    title: {
      text: '计步图'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      // boundaryGap: true,
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: [
      // {
      //   name: 'Email',
      //   type: 'line',

      //   data: [60, 66,62,63,70,89,90,65,61,63,64,68,77,72,82,81,75,83,65,71,67,68,76,77,79,80,81,82,83,84,85,86,87,88,65]
      // },

    ]
  },
  breathe_opt: {
    title: {
      text: '呼吸图'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {},
    series: []
  },
}
